import request from '@/http/request';

// 创建反馈
export function postFeedback(data) {
  return request({
    url: '/api/v1/ops/feedback_create',
    method: 'post',
    data,
  });
}
export function getUserInfo(data) {
  return request({
    url: '/api/v1/ops/wechat/get_user_info',
    method: 'post',
    data,
  });
}


export function oauthCallback(data) {
  return request({
    url: '/api/v1/ops/wechat/oauth_callback',
    method: 'post',
    data,
  });
}
// 获取反馈列表
export function getFeedbackList(params) {
  return request({
    url: '/api/v1/ops/feedback_list',
    method: 'get',
    params,
  });
}

export function getOauthUrl(params) {
  return request({
    url: '/api/v1/ops/wechat/get_oauth_url',
    method: 'get',
    params,
  });
}

export function testWechatMessage(data) {
  return request({
    url: '/api/v1/ops/wechat/test_message',
    method: 'post',
    data,
  });
}

// 上传附件
export function uploadAttachment(feedbackId, file) {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: `/api/v1/ops/feedback/${feedbackId}/attachments`,
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// 答复反馈
export function replyFeedback(data) {
  return request({
    url: '/api/v1/ops/feedback_reply',
    method: 'post',
    data,
  });
}
